import { c as _c } from "react/compiler-runtime";
import { AnnotationQuestionIcon } from '@systemeio/icons';
import { LocaleEnum } from '@systemeio/types';
import type { RefObject } from 'react';
import LinkWithoutPrefetch from 'shared/components/link-without-prefetch';
import { LanguageMenu } from 'shared/components/navbar/components/language-menu';
import { getItemClassName } from 'shared/components/navbar/components/menu-link';
import { Notifications } from 'shared/components/navbar/components/notifications';
import { ProfileMenu } from 'shared/components/navbar/components/profile-menu';
import { NAVBAR_ICON_BUTTON_CLASS_NAME } from 'shared/components/navbar/constants';
import { getHelpPageUrl } from 'shared/components/navbar/utils/get-help-page-url';
import { pageRoute } from 'shared/constants/routes.constants';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { useMetadataFromServer } from 'shared/hooks/use-metadata-from-server';
import { useRouter } from 'shared/hooks/use-router';
import useUser from 'shared/hooks/use-user';
import { isSIO } from 'shared/utils/is-sio';
import { twJoin } from 'tailwind-merge';
interface DesktopActionsProps {
  actionsRef: RefObject<HTMLDivElement | null>;
}
export function DesktopActions(t0) {
  const $ = _c(19);
  const {
    actionsRef
  } = t0;
  const {
    pathname
  } = useRouter();
  const {
    isSupportImpersonation,
    isWorkspaceOwner,
    user
  } = useUser();
  const {
    t
  } = useLocoTranslation();
  const {
    data: metadata
  } = useMetadataFromServer();
  const t1 = metadata?.hostOnServer;
  let t2;
  if ($[0] !== t1) {
    t2 = isSIO(t1);
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const isSio = t2;
  let t3;
  if ($[2] !== isSupportImpersonation || $[3] !== isWorkspaceOwner || $[4] !== pathname || $[5] !== t || $[6] !== user?.userPlanId) {
    t3 = user?.userPlanId === 40 && isWorkspaceOwner && !isSupportImpersonation && <LinkWithoutPrefetch aria-current={pathname.includes(pageRoute.ProfileUserPlan) ? "page" : undefined} className={twJoin(getItemClassName(pathname.includes(pageRoute.ProfileUserPlan)), "px-2")} data-test-id="upgrade-plan-button" href={pageRoute.ProfileUserPlan}>{t("header.top_menu.upgrade")}</LinkWithoutPrefetch>;
    $[2] = isSupportImpersonation;
    $[3] = isWorkspaceOwner;
    $[4] = pathname;
    $[5] = t;
    $[6] = user?.userPlanId;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== isSio || $[9] !== t || $[10] !== user?.dashboardLocale) {
    t4 = isSio && <a aria-label={t("header.top_menu.help")} className={NAVBAR_ICON_BUTTON_CLASS_NAME} data-test-id="help-button" target="_blank" rel="noreferrer" href={getHelpPageUrl(user?.dashboardLocale ?? LocaleEnum.ENGLISH)}><AnnotationQuestionIcon className="size-5" /></a>;
    $[8] = isSio;
    $[9] = t;
    $[10] = user?.dashboardLocale;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  let t6;
  let t7;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Notifications isDesktop={true} />;
    t6 = <ProfileMenu />;
    t7 = <LanguageMenu isDesktop={true} />;
    $[12] = t5;
    $[13] = t6;
    $[14] = t7;
  } else {
    t5 = $[12];
    t6 = $[13];
    t7 = $[14];
  }
  let t8;
  if ($[15] !== actionsRef || $[16] !== t3 || $[17] !== t4) {
    t8 = <div ref={actionsRef} className="ml-auto flex shrink-0 items-center gap-1">{t3}{t4}{t5}{t6}{t7}</div>;
    $[15] = actionsRef;
    $[16] = t3;
    $[17] = t4;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  return t8;
}